import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  FormErrorMessages,
  TextInput,
  generateValidation,
  SharedFormMessages as formMessages,
} from 'ecs-react-components/dist/index.es';
import { Button } from 'react-bootstrap';
import { messages } from './ProvideEmailForm.i18n';
import { validations } from './ProvideEmailForm.validations';
import { saveProvidedUserEmail } from '../../../redux/modules/user-profile/user-profile-middleware';
import * as MsgBarActions from '../../../redux/modules/system-shared/message-bar-action-creator';
import { setIsDedicatedWorkflow } from '../../../redux/modules/workflow/workflow-action-creator';
import history from '../../../history';

class ProvideEmailForm extends Component {
  componentDidMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(true));
  }

  componentWillUnmount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  onBackButtonEvent(event) {
    event.preventDefault();
    history.push('/login');
  }

  onSubmit = (values) => {
    const { user } = this.props;

    if (!values.userEmail) {
      throw new SubmissionError({
        userEmail: {
          required: true,
        },
      });
    }

    if (user.email.toLowerCase() !== values.userEmail.toLowerCase()) {
      this.props.dispatch(saveProvidedUserEmail(user.userId, values.userEmail, () => history.push('/dashboard')));
      return;
    }
    this.props.dispatch(MsgBarActions.showErrorMessage('emailNotUpdatedMessage'));
  }

  clearAlert = () => {
    this.props.dispatch(MsgBarActions.dismissMessage());
  }

  renderField = (fieldMeta) => (
    <div className="mb-3">
        <TextInput
          email={validations.userEmail.email}
          required={validations.userEmail.required}
          field={fieldMeta}
          qaTag="userEmail"
        />
        {
        fieldMeta.meta.error ?
          <label htmlFor={fieldMeta.input.name}>
            <FormErrorMessages field={fieldMeta}
              customMessage={<FormattedMessage { ...formMessages.error.email } />}
            />
          </label> :
          null
        }
    </div>
  );

  render() {
    const { handleSubmit } = this.props;

    return (
      <form onSubmit={ handleSubmit(this.onSubmit) }
        onChange={this.props.onFormChange}
      >
            <div className="row justify-content-md-center mt-3">
              <div className="col-md-8 col-xl-6">
                <div className="card p-3" >
                  <div className="card-body">
                    <h5 className="card-title" id="content">
                      <FormattedMessage {...messages.page.title} />
                    </h5>
                    <p className="card-text">
                    <FormattedMessage {...messages.page.instruction} />
                    </p>
                    <Field name="userEmail" component={this.renderField} />
                    <Button type="submit" data-qa-item="provide_email">
                        <FormattedMessage {...messages.button.continue } />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
      </form>
    );
  }
}

ProvideEmailForm.propTypes = {
  dispatch: PropTypes.func,
  intl: PropTypes.object,
  handleSubmit: PropTypes.func,
  patient: PropTypes.object,
  history: PropTypes.object,
  user: PropTypes.object,
  onFormChange: PropTypes.func,
  userEmail: PropTypes.string,
  onChange: PropTypes.func,
  language: PropTypes.string,
};

const mapStateToProps = (state) => ({
  patient: state.profile.patient,
  user: state.profile.user,
  userEmail: state.profile.user.email,
  language: state.language.languageCode,
  initialValues: {
    userEmail: state.profile.user.email,
  },
});

const formConfig = {
  form: 'provideEmailForm',
  ...generateValidation(validations),
};

export default ((connect(mapStateToProps)(reduxForm(formConfig)(injectIntl(ProvideEmailForm)))));
